<template>
  <Modal title="Единицы измерения" @backdrop-click="close">
    <template slot="body">
      <div class="body__select">
        <Select :default-key="currentUnitKey" :options="possibleUnits" @input="selectUnit" />
      </div>
    </template>
    <template slot="footer">
      <div class="modal__buttons">
        <button
          v-focus
          type="button"
          class="modal-default-button btn btn-danger"
          @click="close"
        >
          Закрыть
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/_shared/components/ui/Modal';
import Select from '@/_shared/components/ui/Select';
export default {
  components: {
    Modal,
    Select,
  },
  emits: ['select'],
  props: {
    unitValue: {
      type: String,
      default: 'мм',
      validator(value) {
        return ['мм', 'м', 'см'].includes(value);
      },
    },
  },
  computed: {
    currentUnitKey() {
      const unitsKeys = {};
      Object.entries(this.possibleUnits).forEach(([key, value]) => {
        unitsKeys[value] = key;
      });
      return unitsKeys[this.unitValue];
    },
    possibleUnits() {
      return  {
        mm: "мм",
        sm: "см",
        m: "м",
      };
    },
  },
  methods: {
    selectUnit(value) {
      this.$emit('select', this.possibleUnits[value]);
      this.close();
    },
    close() {
      document.querySelector("body").style.overflow = "auto";
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.body__select {
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/stock/features/count-entity-units/UnitModal.vue